<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-praying-hands</v-icon>
      <span class="title ml-2">Editar pedido de oración</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="formEdit">
        <v-text-field
          v-model="value.nombre"
          label="Nombre"
          :error-messages="errNombre"
        ></v-text-field>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="value.telefono"
              label="Teléfono"
              :error-messages="errTelefono"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="value.email"
              label="Correo electrónico"
              :error-messages="errEmail"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-textarea
          v-model="value.mensaje"
          label="Mensaje"
          :error-messages="errMensaje"
        ></v-textarea>
        <v-row>
          <v-col cols="6">
            <v-switch v-model="value.aprobado" color="primary" label="Aprobado"></v-switch>
          </v-col>
          <v-col cols="6">
            <v-switch v-model="value.publico" color="primary" disabled label="Publico"></v-switch>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="saveOracion()">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required, email, numeric } from 'vuelidate/lib/validators'
export default {
  props: {
    id: {
      type: String,
      default: () => ''
    },
    value: {
      type: Object,
      default: () => {
        return {
          nombre: '',
          telefono: '',
          email: '',
          mensaje: '',
          publico: false,
          aprobado: false
        }
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    errNombre () {
      const errs = []
      if (!this.$v.value.nombre.$dirty) return errs
      !this.$v.value.nombre.required && errs.push('El nombre es requerido')
      return errs
    },
    errTelefono () {
      const errs = []
      if (!this.$v.value.telefono.$dirty) return errs
      !this.$v.value.telefono.numeric && errs.push('El teléfono no es valido')
      return errs
    },
    errEmail () {
      const errs = []
      if (!this.$v.value.email.$dirty) return errs
      !this.$v.value.email.email && errs.push('El correo electrónico no es valido')
      return errs
    },
    errMensaje () {
      const errs = []
      if (!this.$v.value.mensaje.$dirty) return errs
      !this.$v.value.mensaje.required && errs.push('El mensaje es requerido')
      return errs
    }
  },
  methods: {
    async saveOracion () {
      this.$v.value.$touch()
      if (!this.$v.value.$invalid) {
        try {
          this.loading = true
          await this.$http.oraciones.put(`/${this.id}`, this.value)
          this.loading = false
          this.$emit('saved')
        } catch (error) {
          this.loading = false
          window.alert('Ha ocurrido un error al guardar los cambios')
        }
      }
    }
  },
  validations: {
    value: {
      nombre: { required },
      telefono: { numeric },
      email: { email },
      mensaje: { required }
    }
  }
}
</script>
